import { InProductTrialTypeEnum } from '@nirvana/shared/dtos/types/in-product-trials';

export const GzLandingPageProductLinks = {
  [InProductTrialTypeEnum.OfficeSecurityPack]: {
    link: 'https://www.bitdefender.com/business/support/en/77211-463916-gravityzone-business-security--for-small-business-security-.html',
    id: 'bs-page',
  },
  [InProductTrialTypeEnum.NextGen]: {
    link: 'https://www.bitdefender.com/business/support/en/77209-262794-gravityzone-business-security-premium.html',
    id: 'bsp-page',
  },
  [InProductTrialTypeEnum.NextGenWithReconfigurePopup]: {
    link: 'https://www.bitdefender.com/business/support/en/77209-463917-gravityzone-business-security-premium--for-small-business-security-.html',
    id: 'bsp-page-with-reconfigure',
  },
  [InProductTrialTypeEnum.Atd]: {
    link: 'https://www.bitdefender.com/business/support/en/77209-262793-gravityzone-business-security-enterprise.html',
    id: 'bse-page',
  },
  [InProductTrialTypeEnum.XdrFull]: {
    link: 'https://www.bitdefender.com/business/support/en/77211-429724-extended-detection-and-response--xdr-.html',
    id: 'xdr-full-page',
  },
  [InProductTrialTypeEnum.XdrSensors]: {
    link: 'https://www.bitdefender.com/business/support/en/77211-429724-extended-detection-and-response--xdr-.html',
    id: 'xdr-sensors-page',
  },
  [InProductTrialTypeEnum.PatchManagement]: {
    link: 'https://www.bitdefender.com/business/support/en/77211-320646-patch-management.html',
    id: 'patch-page',
  },
  [InProductTrialTypeEnum.VolumeEncryption]: {
    link: 'https://www.bitdefender.com/business/support/en/77211-320645-full-disk-encryption.html',
    id: 'encryption-page',
  },
  [InProductTrialTypeEnum.MobileSecurity]: {
    link: 'https://www.bitdefender.com/business/support/en/77211-320644-gravityzone-security-for-mobile.html',
    id: 'mobile-page',
  },
  [InProductTrialTypeEnum.IntegrityMonitor]: {
    link: 'https://www.bitdefender.com/business/support/en/77211-398422-integrity-monitoring.html',
    id: 'integrity-page',
  },
  [InProductTrialTypeEnum.ContainerProtection]: {
    link: 'https://www.bitdefender.com/business/support/en/77211-398421-container-security.html',
    id: 'containers-page',
  },
  [InProductTrialTypeEnum.StorageProtection]: {
    link: 'https://www.bitdefender.com/business/support/en/77211-398423-security-for-storage.html',
    id: 'storage-page',
  },
  [InProductTrialTypeEnum.NadAndEraAddon]: {
    link: 'https://www.bitdefender.com/business/support/en/77211-1125602-network-attack-defense-and-risk-management.html',
    id: 'network-attack-defense-and-risk-management-page',
  },
  [InProductTrialTypeEnum.WebAccessAndDeviceControlAddon]: {
    link: 'https://www.bitdefender.com/business/support/en/77211-1125603-web-access-and-device-control.html',
    id: 'web-access-and-device-control-page',
  },
};

export enum AccordionItemLinks {
  FilelessAttackDefense = 'https://www.bitdefender.com/business/gravityzone-platform/fileless-attack-defense.html',
  NetworkAttackDefense = 'https://www.bitdefender.com/business/gravityzone-platform/network-attack-defense.html',
  ProcessInspection = 'https://www.bitdefender.com/business/gravityzone-platform/process-inspector.html',
  HyperDetect = 'https://www.bitdefender.com/business/gravityzone-platform/hyperdetect.html',
  AttackForensicsAndVisualization = 'https://www.bitdefender.com/business/gravityzone-platform/incident-visualization.html',
  EulaBusinessSolution = 'https://www.bitdefender.com/site/view/eula-business-solutions.html',
  PrivacyPolicy = 'https://www.bitdefender.com/site/view/legal-privacy-policy-for-bitdefender-business-solutions.html',
  ProductTrialsFaq = 'https://www.bitdefender.com/business/support/en/77211-296265-product-trials-faq.html',
}

export enum MspAccordionItemLinks {
  Eula = 'https://www.bitdefender.com/site/view/eula-business-solutions.html',
  PrivacyPolicy = 'https://www.bitdefender.com/site/view/legal-privacy-policy-for-bitdefender-business-solutions.html',
  FAQ = 'https://www.bitdefender.com/business/support/en/77211-452436-msp-product-trials-faq.html',
}

export const GzLandingPageDemoLinks = {
  [InProductTrialTypeEnum.VolumeEncryption]: 'https://www.youtube-nocookie.com/embed/-jkwLfV1m1w?rel=0',
};
